module.exports = __webpack_public_path__ + "img/after3.c589a476.jpg";